import React from 'react';
import PropTypes from 'prop-types';

export default function PadIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148845' />
      <g fill={fill} data-name='Grupo 151205'>
        <path d='M7.901 11.715h3.52V18h-3.52z' data-name='Retângulo 1236' />
        <path
          d='M9.66 2 .999 10.659h1.527v7.309h4.373v-6.957h5.49v6.957h4.4v-7.309h1.5Z'
          data-name='Caminho 11779'
        />
      </g>
    </svg>
  );
}

PadIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

PadIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
